export * from './src/partner-promotion-item';
